import { OPEN_DIALOG, CLOSE_DIALOG, CLOSE_ALL_DIALOGS } from 'store/actions/actionTypes';
import {
  INFO,
  QR_CODE,
  METAMASK,
  PLAY_GAME,
  LOW_BALANCE,
  NEED_TO_LOGIN,
  SECURITY_INFO,
  NO_INTERNET_CONNECTION,
  NEED_TO_SIGN,
} from 'constants/dialogs';

const defaultState = {
  [INFO]: false,
  [QR_CODE]: false,
  [METAMASK]: false,
  [PLAY_GAME]: false,
  [LOW_BALANCE]: false,
  [SECURITY_INFO]: false,
  [NEED_TO_LOGIN]: false,
  [NEED_TO_SIGN]: false,
  [NO_INTERNET_CONNECTION]: false,
};

function dialogReducer(state = defaultState, action) {
  switch (action.type) {
    case OPEN_DIALOG:
      return {
        ...state,
        [action.payload]: true,
      };
    case CLOSE_DIALOG:
      return {
        ...state,
        [action.payload]: false,
      };
    case CLOSE_ALL_DIALOGS:
      return {
        ...defaultState,
      };
    default:
      return state;
  }
}

export default dialogReducer;
